import React, { useCallback, useEffect, useState } from "react";
import LandscapeProgramLayout from "../LandscapeProgramLayout";
import cn from "../../../utils/cn";
import BottomNav from "../BottomNav";
import { useAuthContext } from "../../../context/auth";
import useCountDown from "../../../hooks/useCountDown";
import CircularProgress from "../../CircularProgress";

function CoolDown() {
  const {
    circuitProgram,
    weightProgram,
    hiluxProgram,
    sendSetStep,
    step: globalStep,
  } = useAuthContext();
  const program = hiluxProgram ?? circuitProgram ?? weightProgram;

  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [step, setStep] = useState(0);
  const { count, start, reset } = useCountDown(
    40,
    useCallback(() => {
      setStep((prev) => {
        if (program?.coolDownMovements.length === prev + 1) {
          sendSetStep(globalStep + 1);
          return 0;
        }
        return prev + 1;
      });
    }, [program, sendSetStep]),
    true,
  );

  // Initial mount: start immediately
  useEffect(() => {
    start();
    videoRef.current?.play();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When step changes (new movement), reset and restart timer
  useEffect(() => {
    if (step === 0) return; // Skip on initial mount
    reset();
    start();
    videoRef.current?.play();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  if (!program) return <></>;
  const nowCoolDown = program.coolDownMovements[step];
  const nowCoolDownVideo =
    (nowCoolDown as any)?.video ?? nowCoolDown?.movement?.video;
  const nowCoolDownName =
    (nowCoolDown as any)?.name ?? nowCoolDown?.movement?.name;

  return (
    <LandscapeProgramLayout step={6}>
      <div className="flex h-full">
        <div className="min-w-[364px] h-full">
          <p className="gradient-text uppercase italic text-[32px] font-bold mt-[70px] ml-[50px]">
            STEP
          </p>
          <div className="flex flex-col w-full pl-[30px] gap-2 mt-[68px]">
            {program.coolDownMovements.map((movement, index) => (
              <div
                className={cn(
                  "rounded-l-xl px-12 py-4 text-[32px] text-[#48505F] whitespace-nowrap",
                  index === step && "bg-white text-black",
                )}
                key={index}
              >
                {index + 1}.{" "}
                {(movement as any)?.name ?? movement.movement?.name}
              </div>
            ))}
          </div>
        </div>
        <div className="flex-1 bg-white h-full relative">
          <video
            className="w-full h-full object-cover"
            ref={videoRef}
            loop
            muted
            key={nowCoolDownVideo}
          >
            <source src={nowCoolDownVideo} type="video/mp4" />
          </video>
          <div className="absolute bottom-10 right-10 w-[310px] h-[310px]">
            <CircularProgress maxValue={40} value={count} />
          </div>
        </div>
      </div>
      <BottomNav />
    </LandscapeProgramLayout>
  );
}

export default CoolDown;
